import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { RefreshCw, AlertTriangle } from "lucide-react";
import { adminApi } from "@/lib/api";

export const usd = (v) => `$${Number(v || 0).toFixed(v < 1 ? 3 : 2)}`;

export const UsageBar = ({ u, testid = "apify-usage" }) => {
  const color = u.blocked ? "#E3242B" : u.pct >= 70 ? "#f59e0b" : "#10b981";
  return (
    <div>
      <div className="flex items-baseline justify-between text-xs font-mono mb-1">
        <span data-testid={`${testid}-used`}>{usd(u.used_usd)} / {usd(u.limit_usd)} usati</span>
        <span data-testid={`${testid}-pct`} style={{ color }}>{u.pct}%</span>
      </div>
      <div className="h-2 bg-[#e5e9eb] rounded-full overflow-hidden">
        <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${Math.min(100, u.pct)}%`, background: color }} />
      </div>
      <div className="flex justify-between text-[11px] text-[#5b6168] mt-1">
        <span data-testid={`${testid}-remaining`}>Residuo: <b>{usd(u.remaining_usd)}</b></span>
        <span data-testid={`${testid}-renewal`}>Rinnovo: {u.cycle_end}</span>
      </div>
    </div>
  );
};

const Details = ({ u }) => (
  <div className="grid md:grid-cols-2 gap-4 mt-4">
    <ul data-testid="apify-usage-services" className="text-[11px] font-mono space-y-1">
      {u.services.map((s) => (
        <li key={s.name} className="flex justify-between border-b border-[#e5e9eb] pb-1">
          <span className="truncate pr-2">{s.name}</span><span>{usd(s.usd)}</span>
        </li>
      ))}
      {!u.services.length && <li className="text-[#6b7280]">Nessun consumo nel ciclo</li>}
    </ul>
    <DailyChart daily={u.daily} testid="apify-usage-daily-chart" />
  </div>
);

export const DailyChart = ({ daily, testid }) => (
  <div data-testid={testid} className="h-24">
    <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 300, height: 96 }}>
      <BarChart data={daily}>
        <XAxis dataKey="date" tick={{ fontSize: 9 }} tickFormatter={(d) => d.slice(5)} />
        <Tooltip formatter={(v) => usd(v)} />
        <Bar dataKey="usd" fill="#2B3036" radius={[2, 2, 0, 0]} maxBarSize={18} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export const ApifyUsageCard = ({ configured }) => {
  const [u, setU] = useState(null);
  const [err, setErr] = useState("");
  const load = () => adminApi.apifyUsage().then((d) => { setU(d); setErr(""); })
    .catch((e) => setErr(e.response?.data?.detail || "Errore lettura credito"));
  useEffect(() => { if (configured) load(); }, [configured]);
  if (!configured) return null;

  return (
    <div data-testid="apify-usage-card" className="mt-3 p-4 bg-white border border-[#d5dbde] rounded-sm">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-wider">Credito Apify (mese)</span>
        <div className="flex items-center gap-2">
          {u?.blocked && (
            <span data-testid="apify-usage-blocked-badge" className="flex items-center gap-1 text-[10px] font-mono text-white bg-[#E3242B] px-2 py-0.5 rounded-full">
              <AlertTriangle size={11} /> RICERCA SOCIAL BLOCCATA
            </span>
          )}
          <button data-testid="apify-usage-refresh-btn" onClick={load} className="text-[#5b6168] hover:text-[#2B3036] transition-colors">
            <RefreshCw size={14} />
          </button>
        </div>
      </div>
      {err && <p data-testid="apify-usage-error" className="text-xs text-[#E3242B]">{err}</p>}
      {u && <><UsageBar u={u} /><Details u={u} /></>}
      {!u && !err && <p className="text-xs text-[#6b7280] font-mono">Carico…</p>}
    </div>
  );
};
